import { useState, useEffect } from "react";
import useModal from "../../../../hooks/useModal";
import ModalBare from "../../../../components/ModalBare";
import { Button } from "@oc-labs/wt-storybook";

const AVAILABLE_FONTS = [
  { value: "Arial", label: "Arial" },
  { value: "Helvetica", label: "Helvetica" },
  { value: "Times New Roman", label: "Times New Roman" },
  { value: "Georgia", label: "Georgia" },
  { value: "Courier New", label: "Courier New" },
  { value: "Verdana", label: "Verdana" },
  { value: "Trebuchet MS", label: "Trebuchet MS" },
  { value: "Inter", label: "Inter" },
  { value: "Roboto", label: "Roboto" },
  { value: "Open Sans", label: "Open Sans" },
  { value: "Lato", label: "Lato" },
  { value: "Poppins", label: "Poppins" },
  { value: "Montserrat", label: "Montserrat" },
  { value: "Source Sans Pro", label: "Source Sans Pro" },
];

export default function FontSettingsModal({ company, onSave }) {
  const modal = useModal("editPopUp");
  const [fonts, setFonts] = useState({
    primaryFont: company?.primaryFont || "",
    secondaryFont: company?.secondaryFont || "",
  });

  useEffect(() => {
    if (modal.isOpen) {
      setFonts({
        primaryFont: company?.primaryFont || "",
        secondaryFont: company?.secondaryFont || "",
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal.isOpen]);

  const handleFontChange = (key, value) => {
    setFonts({ ...fonts, [key]: value });
  };

  const handleSave = () => {
    console.log('[FontSettingsModal] Saving fonts:', fonts);
    onSave?.({
      primaryFont: fonts.primaryFont,
      secondaryFont: fonts.secondaryFont,
    });
    modal.close();
  };

  return (
    <ModalBare name="editPopUp" title="Font Settings" className="min-w-lg">
      <p className="text-sm text-gray-600 px-6 py-2">Choose your primary and secondary fonts</p>
      <div className="px-8 space-y-6 mt-4">
        {/* Primary Font */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Primary font</label>
          <select
            value={fonts.primaryFont}
            onChange={e => handleFontChange('primaryFont', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded text-sm bg-white"
          >
            <option value="">Select a font</option>
            {AVAILABLE_FONTS.map((font) => (
              <option key={font.value} value={font.value}>
                {font.label}
              </option>
            ))}
          </select>
        </div>
        {/* Secondary Font */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Secondary font</label>
          <select
            value={fonts.secondaryFont}
            onChange={e => handleFontChange('secondaryFont', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded text-sm bg-white"
          >
            <option value="">Select a font</option>
            {AVAILABLE_FONTS.map((font) => (
              <option key={font.value} value={font.value}>
                {font.label}
              </option>
            ))}
          </select>
        </div>
        {/* Botones Reset */}
        <div className="flex justify-center mt-8 mb-8 gap-4">
          <button
            type="button"
            onClick={() => {
              setFonts({
                primaryFont: '',
                secondaryFont: '',
              });
            }}
            className="px-8 py-2 rounded-3xl bg-gray-200 text-black font-medium hover:bg-gray-300 transition whitespace-nowrap cursor-pointer"
          >
            Reset to Default
          </button>
          <Button type="primary" onClick={handleSave} className="px-8">
            Save Changes
          </Button>
        </div>
      </div>
    </ModalBare>
  );
}
